import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
import { drawerWidth } from './MainDrawer';
import Typography from '@mui/material/Typography';
import { useHistory } from 'react-router-dom';
import { Avatar, Box, Menu, MenuItem, Tooltip } from '@mui/material';
import { AppContext } from '../providers/AppContext';

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));
  
export function MainHeader({open, toggleDrawer}){
    var history = useHistory();
    const {user, logout} = React.useContext(AppContext);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const handleLogout = (event) => {
      setAnchorElUser(null);
      logout();
    };
    const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };
    return <>
        <AppBar position="absolute" open={open}  className="no-print">
            <Toolbar
                sx={{
                pr: '24px', // keep right padding when drawer closed
                }}
            >
              
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={toggleDrawer}
                  sx={{
                      marginRight: '36px',
                      ...(open && { display: 'none' }),
                  }}
                  >
                  <MenuIcon />
                </IconButton>
                <Typography
                  onClick={() => history.push("/")}
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  sx={{ flexGrow: 1 }}
                  >
                  Herramientas para PHRF
                </Typography>
                <Box>
                 {user !== false && <>
                  <Tooltip title="Open settings">
                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                      <Typography
                        component="span"
                        color="#FFFFFF"
                        marginRight="10px"
                        noWrap
                        >{user.name}</Typography>
                      <Avatar alt={user.name} src={user.picture} />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                  >
                    
                      <MenuItem onClick={handleLogout}>
                        <Typography textAlign="center">Salir</Typography>
                      </MenuItem>
                  </Menu>
                  </>}
                </Box>
            </Toolbar>
            </AppBar>
        </>


}
